import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import CustomShowerGlassPage from "@/pages/CustomShowerGlassPage";
import WindowGlassPage from "@/pages/WindowGlassPage";
import CustomMirrorsPage from "@/pages/CustomMirrorsPage";
import CommercialGlassPage from "@/pages/CommercialGlassPage";
import WebsiteAccessibilityPage from "@/pages/WebsiteAccessibilityPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/services/custom-shower-glass" element={<CustomShowerGlassPage />} />
              <Route path="/services/window-glass-replacement" element={<WindowGlassPage />} />
              <Route path="/services/custom-mirrors" element={<CustomMirrorsPage />} />
              <Route path="/services/commercial-glass" element={<CommercialGlassPage />} />
              <Route path="/website-accessibility" element={<WebsiteAccessibilityPage />} />
            </Routes>
          </main>
          <Footer />
          <AccessibilityWidget />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
